import { validate as isUUID } from 'uuid';

import { type UUID } from '~/types/common';

/**
 * Gets the Vestigas user ID from a creator string. Used in the createdBy key of an asset chain.
 */
export const getCreatorId = (creatorString?: string): UUID | undefined => {
  if (typeof creatorString !== 'string') {
    return undefined;
  }

  const creatorId = creatorString.split('_').pop();

  if (!creatorId) {
    return undefined;
  }

  if (isUUID(creatorId)) {
    return creatorId;
  }

  return undefined;
};
